import { combineReducers }          from 'redux'
import { routeReducer as routing }  from 'react-router-redux'
import leagues                      from './leagues'
import news                         from './news'
import scoreboard                   from './scoreboard'
import standings                    from './standings'
import schedule                     from './schedule'
import gamePackage                  from './gamePackage'
import utils                        from './utils'
import page                         from './page'
import clubhouse                    from './clubhouse'
import apiUrls                      from './apiUrls'

export const rootReducer = combineReducers({
  news,
  leagues,
  scoreboard,
  standings,
  gamePackage,
  clubhouse,
  routing,
  utils,
  schedule,
  page,
  apiUrls
})

export default rootReducer



// WEBPACK FOOTER //
// ../app/reducers/index.js